import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "./Layout";
import Dashboard from "./pages/Dashboard";
import Leads from "./pages/Leads";
import Analytics from "./pages/Analytics";
import Login from "./pages/Login";
import PrivateRoute from "./PrivateRoute";
import { Navigate } from "react-router-dom";
import { Toaster } from "react-hot-toast";

function App() {
    return (
        <>
            <Toaster position="top-right" />
            <BrowserRouter>
                <Routes>

                    <Route path="/login" element={<Login />} />

                    <Route
                        path="/"
                        element={
                            <PrivateRoute>
                                <Layout />
                            </PrivateRoute>
                        }
                    >
                        {/* 👇 ADD THIS */}
                        <Route index element={<Navigate to="dashboard" />} />

                        <Route path="dashboard" element={<Dashboard />} />
                        <Route path="leads" element={<Leads />} />
                        <Route path="analytics" element={<Analytics />} />
                    </Route>

                </Routes>
            </BrowserRouter>
        </>
    );
}

export default App;